// Consider doing the donut chart as pure css - not easy to always display the score
// in the middle of the donut in Highcharts

import React, { Component } from "react"
import Highcharts from "highcharts"
import HighchartsMore from "highcharts-more"
import SolidGauge from "highcharts-solid-gauge"
import ReactHighcharts from "react-highcharts"
import DualComparisonPercentage from "./Shared/DualComparisonPercentage"

HighchartsMore(ReactHighcharts.Highcharts)
SolidGauge(ReactHighcharts.Highcharts)

class DonutChart extends Component {
  constructor() {
    super()
    // this.state = {visible: false};
  }

  graphCallback = chart => {
    // Hack!
    this.reflowTimeout = setTimeout(() => {
      // this.setState({visible: true});
      /*if (chart) {
        chart.reflow()
      }*/
      //chart.tooltip.refresh([chart.series[0].points[0]]);
    }, 1000)
  }

  componentWillUnmount() {
    clearTimeout(this.reflowTimeout)
  }

  render() {
    const chartOptions = {
      chart: {
        type: "solidgauge"
      },

      credits: false,

      title: {
        text: null
      },

      tooltip: {
        borderWidth: 0,
        backgroundColor: "none",
        shadow: false,
        style: {
          fontSize: "16px"
        },
        pointFormat:
          '<span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}' +
          this.props.units +
          "</span>",
        positioner: function(labelWidth) {
          return {
            x: 180 - labelWidth / 2,
            y: 190
          }
        }
      },

      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [
          {
            // Track for Move
            outerRadius: "100%",
            innerRadius: "80%",
            backgroundColor: Highcharts.Color(Highcharts.getOptions().colors[0])
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }
        ]
      },

      yAxis: {
        min: 0,
        max: this.props.maxValue,
        lineWidth: 0,
        tickPositions: []
      },

      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false
          },
          linecap: "round",
          stickyTracking: false,
          rounded: true
        }
      },

      series: [
        {
          name: "Move",
          data: [
            {
              color: Highcharts.getOptions().colors[0],
              radius: "100%",
              innerRadius: "80%",
              y: this.props.value
            }
          ]
        }
      ]
    }

    return (
      <div>
        <ReactHighcharts config={chartOptions} callback={this.graphCallback} />
        <DualComparisonPercentage
          currentValue={this.props.value}
          leftComparisonTitle={this.props.leftComparisonTitle}
          leftComparisonValue={this.props.leftComparisonValue}
          rightComparisonTitle={this.props.rightComparisonTitle}
          rightComparisonValue={this.props.rightComparisonValue}
        />
      </div>
    )
  }
}

export default DonutChart



// WEBPACK FOOTER //
// ./src/Components/Graphs/DonutChart.js